module.exports = __webpack_public_path__ + "img/home-in-the-news-slide.jpg?cbc6270a4c949d30402d66afd32f72d8";